module.exports = require("cytoscape-panzoom");